import React, { useState } from "react";
import { ButtonProps } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { AiFillFileExcel } from "react-icons/ai";
import { ExportExcelDialog } from "./ExportExcelDialog";
import { useGetExportFields } from "common/models/hooks/useGetExportFields";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

export interface ExportButtonProps extends Omit<ButtonProps, "onClick"> {
  groupName: string;
  fileName?: string;
  reportTitle?: string;
  params?: Record<string, any> | (() => Record<string, any>);
  apiURL?: string;
  buttonText?: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  groupName,
  fileName = "Report",
  reportTitle = "",
  params = {},
  apiURL,
  buttonText = "Export",
  variant = "contained",
  color = "primary",
  size = "medium",
  ...rest
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const { data: columns = [], isLoading: columnsLoading } =
    useGetExportFields(groupName);

  const handleDownload = (selectedFields: string[]) => {
    setLoading(true);
    const targetUrl = apiURL || endpoints.genericExport;
    const resolvedParams =
      typeof params === "function" ? params() : params || {};

    const payload = {
      ...resolvedParams,
      groupName,
      fileName,
      reportTitle,
      exportFields: selectedFields,
      parameters: resolvedParams,
    };

    api.downloadExcel(targetUrl, fileName, payload, (isLoading) => {
      setLoading(isLoading);
      if (!isLoading) {
        setDialogOpen(false);
      }
    });
  };

  return (
    <>
      <LoadingButton
        variant={variant}
        color={color}
        size={size}
        loading={loading || columnsLoading}
        loadingPosition="start"
        startIcon={<AiFillFileExcel size={20} />}
        onClick={() => setDialogOpen(true)}
        {...rest}
      >
        {buttonText}
      </LoadingButton>

      <ExportExcelDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        columns={columns}
        onExport={handleDownload}
        loading={loading}
      />
    </>
  );
};
